





































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'

@Component
export default class ComponentModalRemoveGestor extends Vue {
  rmvgstLoading: boolean = false

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get removeGestorLoading() {
    return this.rmvgstLoading
  }

  set removeGestorLoading(value: boolean) {
    this.rmvgstLoading = value
  }

  get removeGestorList() {
    return this.getBackofficeContratosStore.modal.removeGestorList
  }

  closeModalRemoveGestor() {
    this.getBackofficeContratosStore.clearRemoveGestorId()
    this.getBackofficeContratosStore.setShowModalRemoveGestorList(false)
  }

  async removerGestor() {
    this.removeGestorLoading = true
    await this.getBackofficeContratosStore.removeGestorById()
    this.removeGestorLoading = false
    this.closeModalRemoveGestor()
  }
}
